// extracted by mini-css-extract-plugin
export var centerText = "_dr-8";
export var container = "_dr-0";
export var doughnutContainer = "_dr-7";
export var legend = "_dr-a";
export var legendItemColorDisplay = "_dr-b";
export var legendItemLabel = "_dr-d";
export var legendItemValue = "_dr-c";
export var lg = "_dr-5";
export var maxWidth = "_dr-9";
export var md = "_dr-4";
export var responsive = "_dr-6";
export var sm = "_dr-3";
export var xs = "_dr-2";
export var xxs = "_dr-1";